import { render } from "./cardScroller.vue?vue&type=template&id=4ebde0a7&scoped=true"
import script from "./cardScroller.vue?vue&type=script&lang=js"
export * from "./cardScroller.vue?vue&type=script&lang=js"

import "./cardScroller.vue?vue&type=style&index=0&id=4ebde0a7&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ebde0a7"]])

export default __exports__